module.exports = __webpack_public_path__ + "static/media/icon-sms.b2567c08.svg";